/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading dependencies
 * -----------------------------------------------------------------------------------------------------------
 */
import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import { Notification } from 'element-ui'
import ls from 'src/libs/ls'
/**
 * -----------------------------------------------------------------------------------------------------------
 * Loading vuex modules
 * -----------------------------------------------------------------------------------------------------------
 */
import gsTable from 'components/app/gsTable/store'
import account from 'components/account/store'
import invoice from 'components/invoice/store'
import receipt from 'components/receipt/store'
import user from 'components/user/store'
import role from 'components/role/store'
import admin from 'components/admin/store'
import permission from 'components/permission/store'
import compare from 'components/compare/store'
import carrier from 'components/carrier/store'
import shipment from 'components/shipment/store'
import affiliate from 'components/affiliate/store'
import bank from 'components/bank/store'
import city from 'components/city/store'
import district from 'components/district/store'
import ward from 'components/ward/store'

/**
 * -----------------------------------------------------------------------------------------------------------
 * Vuex base configurations
 * -----------------------------------------------------------------------------------------------------------
 */
Vue.use(Vuex)
import router from 'src/router'
const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  strict: debug,
  state: {
    loading: false,
    logged: false,
    loadingInstance: undefined,
    debugQuery: []
  },
  actions: {
    showNotify: ({ commit }, message) => {
      Notification({
        title: message.title,
        message: message.body,
        type: message.type ? message.type : 'success'
      })
    },
    logged ({ commit }, token) {
      ls.set('authen', token)
      commit('setLogged')
    },
    logout ({ commit }) {
      ls.remove('authen')
      commit('setLogout')
    },
    toggleLoadding ({ commit }, loading = true) {
      commit('loading', loading)
    },
    checkLogged ({ commit }) {
      if (ls.get('authen')) {
        commit('setLogged')
      } else {
        router.push('/login')
      }
    }
  },
  mutations: {
    loading (state, loading) {
      state.loading = loading
    },
    setLogged (state) {
      state.logged = true
    },
    setLogout (state) {
      state.logged = false
    },
    SET_DEBUG (state, queries) {
      state.debugQuery.push(queries)
    }
  },
  getters: {
    loading: (state) => state.loading,
    isLogged: state => state.logged,
    debugQuery: state => state.debugQuery
  },
  modules: {
    gsTable,
    account,
    invoice,
    user,
    role,
    admin,
    permission,
    compare,
    carrier,
    receipt,
    shipment,
    affiliate,
    bank,
    city,
    district,
    ward
  },
  plugins: debug ? [createLogger()] : []
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js